export enum COMMISSION_STATUS {
  PENDING = 'P',
  RECEIVED_PARTIALLY = 'CRP',
  RECEIVED = 'CR',
  RETURNED_PARTIALLY = 'RP',
  RETURNED = 'R',
  PENDING_INVOICE_PAYMENT = 'PIP',
}

export enum COMMISSION_AGENT_TYPE {
  EXTERNAL = 'E',
  AGENT = 'A',
}
